import dateFormat from 'dateformat';
import moment from 'moment';
import lodash from 'lodash';

export default {
  methods: {
    decode(html) {
      const decoder = document.createElement('div');
      decoder.innerHTML = html;
      return decoder.textContent;
    },
    retrieveFromCache(prop, nullify = false) {
      if (this.cached_data[prop]) {
        if (this.cached_data[prop] !== null) {
          this[prop] = this.cached_data[prop];
        }
        if (nullify) {
          this.cached_data[prop] = Array.isArray(this.cached_data[prop]) ? [] : '';
        }
      }
    },

    convertToHours(time) {
      return (time/60).toFixed(2);
    },

    getQuarterOfYear(date) {
      const month = date.getMonth() + 1;
      console.log(date.getYear());
      return `Q${(Math.ceil(month / 3))} ${date.getYear()}`;
    },

    pad(num, size) {
      return (`000000000${num}`).substr(-size);
    },

    formatMoney(n, c, d, t) {
      var c = isNaN(c = Math.abs(c)) ? 2 : c,
        d = d == undefined ? '.' : d,
        t = t == undefined ? ',' : t,
        s = n < 0 ? '-' : '',
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
        j = (j = i.length) > 3 ? j % 3 : 0;
      return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
    },

    currency(amount) {
      return amount.toLocaleString(undefined, { style: 'currency', currency: 'USD' });
    },

    ensureBusinessDate(proposedDate, later = true) {
      // if date is a holiday
      if (later) {
        return this.isHoliday(proposedDate) ?
          this.ensureBusinessDate(proposedDate.addDays(1)) :
          proposedDate;
      }
      return this.isHoliday(proposedDate) ?
        this.ensureBusinessDate(proposedDate.addDays(-1), false) :
        proposedDate;
    },
    isHoliday(proposedDate) {
      // if is weekend
      if (proposedDate.getDay() % 6 === 0) {
        return true;
      }
      // serialize the holiday and proposed date in order to compare objects
      return (this.getHolidays(proposedDate.getFullYear()).map(Number).indexOf(+proposedDate) > 0);
    },
    getHolidays(year) {
      const fixedHolidays = this.getFixedHolidays(year).map((holiday) => {
        const date = new Date(holiday[0], holiday[1], holiday[2]);
        // if this is Saturday
        if (date.getDay() === 6) {
          return date.addDays(-1);
        }
        // if this is Sunday
        if (date.getDay() === 0) {
          return date.addDays(1);
        }
        return date;
      });
      return fixedHolidays.concat(this.getUnfixedHolidays(year));
    },

    getFixedHolidays(year) {
      return [
        [year, 0, 1], // New Year's day
        [year, 6, 4], // Independence Day
        [year, 11, 24], // Christmas Eve
        [year, 11, 25], // Christmas
      ];
    },
    getUnfixedHolidays(year) {
      const thanksgiving = this.getDate(year, 10, 3, 4);
      return [
        this.getDate(year, 4, -1, 1), // Memorial Day
        this.getDate(year, 8, 0, 1), // Labor Day
        thanksgiving, // Thanksgiving Day
        thanksgiving.addDays(1), // Thanksgiving Day after
      ];
    },

    getDate(year, month, week, day) {
      let firstDay = 1;
      if (week < 0) {
        month += 1;
        firstDay -= 1;
      }
      const date = new Date(year, month, (week * 7) + firstDay);
      date.setDate((date.getDate() - date.getDay()) + day);
      return date;
    },
    // Take a date of form '2015-02-01' and convert it into '02/01/2015'
    month(aDate) {
      if (aDate != null && aDate != '' && aDate != '0000-00-00' && new Date(aDate) != NaN && aDate != 'Invalid Date') {
        const theDate = new Date(aDate);
        theDate.setTime(theDate.getTime() + 1 * 86400000);
        // theDate.setTime(theDate.getTime());
        return dateFormat(theDate, 'mm/dd/yyyy');
      }
      return '';
    },
    // Take a date of form '2015-02-01' and convert it into '02/01/2015'
    displayMonthDayYear(aDate) {
      if (aDate != null && aDate != '' && new Date(aDate) != NaN && aDate != 'Invalid Date') {
        const theDate = new Date(aDate);
        theDate.setTime(theDate.getTime() + 1 * 86400000);
        // theDate.setTime(theDate.getTime());
        return dateFormat(theDate, 'mm/dd/yyyy');
      }
      return 'Not Specified';
    },

    formatDate(aDate, format) {
      if (aDate != null && aDate != '' && new Date(aDate) != NaN && aDate != 'Invalid Date') {
        const theDate = new Date(aDate);
        theDate.setTime(theDate.getTime() + 1 * 86400000);
        // theDate.setTime(theDate.getTime());
        return dateFormat(theDate, format);
      }
      return 'Not Specified';
    },

    displayDateTime(aDate) {
      if (aDate !== null && aDate !== '') {
        return moment(aDate).format('M/D/YY h:mm a');
      }
      return aDate;
    },

    displayDate(aDate, format) {
      if (aDate !== null && aDate !== '') {
        return moment(aDate).format(format);
      }
      return aDate;
    },

    dateDifference(date1, date2) {
      // Get 1 day in milliseconds
      var one_day = 1000 * 60 * 60 * 24;

      // Convert both dates to milliseconds
      var date1_ms = (new Date(date1)).getTime();
      var date2_ms = (new Date(date2)).getTime();

      // Calculate the difference in milliseconds
      var difference_ms = date2_ms - date1_ms;

      // Convert back to days and return
      return Math.floor(difference_ms/one_day);
    },

    /**
     *  Removes whitespace and makes a string camelCase.
     */
    camelize(str) {
      if (str === undefined) {
        return undefined;
      }
      return str.toLowerCase().replace(/(?:^\w|[A-Z]|\b\w)/g, (letter, index) => {
        return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
      }).replace(/\s+/g, '');
    },
    splitWordsCamelCase(str) {
      return str.split(/(?=[A-Z])/).map(s => this.ucfirst(s)).join(' ');
    },
    // Capitalize first letter of string.
    ucfirst(str) {
      return str ? str.charAt(0).toUpperCase() + str.slice(1) : str;
    },
    // Capitalize first letter of each word of a string.
    ucwords(str) {
      return (typeof str === 'string' || str instanceof String) ? str.replace(/\w+/g, a => a.charAt(0).toUpperCase() + a.slice(1).toLowerCase()): str;
    },
    capitalize(s) {
      return s && s[0].toUpperCase() + s.slice(1);
    },
    capWordsUnderscore(str) {
      if (str && str.length > 0) {
        const spl = str.split('_');
        let res = '';
        let i = 0;
        for (i; i < spl.length; i += 1) {
          let sep = '';
          if (i !== spl.length - 1) {
            sep = '-';
          }
          res += spl[i].charAt(0).toUpperCase() + spl[i].slice(1) + sep;
        }
        return res;
      }
      return str;
    },
    capWords(str) {
      if (str && str.length > 0) {
        const spl = str.split(' ');
        let res = '';
        let i = 0;
        for (i; i < spl.length; i += 1) {
          let sep = '';
          if (i !== spl.length - 1) {
            sep = ' ';
          }
          res += spl[i].charAt(0).toUpperCase() + spl[i].slice(1) + sep;
        }
        return res;
      }
      return str;
    },
    sanitize(str, delimiter = '_') {
      return str.toLowerCase().replace(/ /g, delimiter).replace(/-/g, delimiter).replace(/_/g, delimiter);
    },
    unsanitize(str) {
      if (str && str.length > 0) {
        return str.replace(/_/g, ' ').replace(/-/g, ' ');
      }
      return str;
    },
    maxLen(text, maxLength) {
      let ret = text;
      if (ret.length > maxLength) {
        ret = `${ret.substr(0, maxLength - 3)}...`;
      }
      return ret;
    },
    truncateText(str, limit = 50) {
      if (str.length > limit) {
        return `${str.substring(0, limit)}...`;
      }
      return str;
    },
    toArray(fileList) {
      return Array.prototype.slice.call(fileList);
    },
    getGlyphicon(glyphMap, key) {
      const glyph = this.lodash.chain(glyphMap)
        .find(theGlyph => theGlyph.slug === key).value();
      return glyph ? glyph.value : 'user';
    },
    calculateSum(group, property) {
      return lodash.reduce(
        group,
        (sum, item) => (item[property] ? sum + parseFloat(item[property]) : sum),
        0,
      );
    },
    isIterable(value) {
      if (typeof value === 'string' || value instanceof String) {
        return false;
      }
      return Symbol.iterator in Object(value);
    },
  },
};
